<template>
	<div @click="handleClick">
		<v-tabs v-bind="$attrs" v-on="$listeners">
			<slot></slot>
		</v-tabs>
	</div>
</template>

<script>
export default {
	name: 'BwScrollTabs',
	props: {
		contentRef: {
			type: String,
			required: true
		},
		offsetY: {
			type: [String, Number],
			default: 0
		}
	},
	methods: {
		handleClick(event) {
			let target = event.target;

			// Traverse up the DOM tree to find an element with an href attribute
			while(target && !target.getAttribute('href')) {
				target = target.parentElement;
			}

			if(target) {
				const href = target.getAttribute('href');
				if(href && href.startsWith('#')) {
					event.preventDefault();
					const targetId = href.substring(1);
					const targetElement = document.getElementById(targetId);

					if(targetElement) {
						const contentComponent = this.findRefComponent(this.$parent, this.contentRef);
						if(contentComponent) {
							const container = contentComponent.$el;

							const offset = this.getOffset(targetElement, container);
							console.log('offset: ', offset);
							console.log('adjusted offset: ', offset - Number(this.offsetY));
							container.scrollTo({
								top: offset - Number(this.offsetY),
								behavior: 'smooth'
							});
						}
					}
				}
			}
		},
		findRefComponent(component, refName) {
			if(component.$refs[refName]) {
				return component.$refs[refName];
			}
			if(component.$parent) {
				return this.findRefComponent(component.$parent, refName);
			}
			return null;
		},
		getOffset(element, container) {
			let offsetTop = 0;
			while(element && element !== container) {
				offsetTop += element.offsetTop;
				element = element.offsetParent;
			}
			return offsetTop;
		}
	}
};
</script>